import { render, staticRenderFns } from "./DoSpacesDisk.vue?vue&type=template&id=0ee64807&"
import script from "./DoSpacesDisk.vue?vue&type=script&lang=js&"
export * from "./DoSpacesDisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee64807')) {
      api.createRecord('0ee64807', component.options)
    } else {
      api.reload('0ee64807', component.options)
    }
    module.hot.accept("./DoSpacesDisk.vue?vue&type=template&id=0ee64807&", function () {
      api.rerender('0ee64807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/disks/DoSpacesDisk.vue"
export default component.exports